import {
  GET_DASHBOARD_CARDS,
  GET_DASHBOARD_CARDS_SUCCESS,
  GET_DASHBOARD_CARDS_FAILED,
  GET_DASHBOARD_CHARTS,
  GET_DASHBOARD_CHARTS_SUCCESS,
  GET_DASHBOARD_CHARTS_FAILED,
  GET_DASHBOARD_RECENT_CONTROLS,
  GET_DASHBOARD_RECENT_CONTROLS_SUCCESS,
  GET_DASHBOARD_RECENT_CONTROLS_FAILED,
} from './types';

const initialState = {
  cards: {
    data: [],
    loading: false,
    error: null,
  },
  charts: {
    controlsOverTime: [],
    complianceDistribution: [],
    loading: false,
    error: null,
  },
  recentControls: {
    data: [],
    loading: false,
    error: null,
  },
};

export default function flowsReducer(state = initialState, action = {}) {
  switch (action.type) {
    // Cards endpoint
    case GET_DASHBOARD_CARDS:
      return {
        ...state,
        cards: {
          ...state.cards,
          loading: true,
          error: null,
        },
      };
    case GET_DASHBOARD_CARDS_SUCCESS:
      return {
        ...state,
        cards: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };
    case GET_DASHBOARD_CARDS_FAILED:
      return {
        ...state,
        cards: {
          ...state.cards,
          loading: false,
          error: action.payload.error,
        },
      };

    // Charts endpoint
    case GET_DASHBOARD_CHARTS:
      return {
        ...state,
        charts: {
          ...state.charts,
          loading: true,
          error: null,
        },
      };
    case GET_DASHBOARD_CHARTS_SUCCESS:
      return {
        ...state,
        charts: {
          controlsOverTime: action.payload.controlsOverTime || [],
          complianceDistribution: action.payload.complianceDistribution || [],
          loading: false,
          error: null,
        },
      };
    case GET_DASHBOARD_CHARTS_FAILED:
      return {
        ...state,
        charts: {
          ...state.charts,
          loading: false,
          error: action.payload.error,
        },
      };

    // Recent controls endpoint
    case GET_DASHBOARD_RECENT_CONTROLS:
      return {
        ...state,
        recentControls: {
          ...state.recentControls,
          loading: true,
          error: null,
        },
      };
    case GET_DASHBOARD_RECENT_CONTROLS_SUCCESS:
      return {
        ...state,
        recentControls: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };
    case GET_DASHBOARD_RECENT_CONTROLS_FAILED:
      return {
        ...state,
        recentControls: {
          ...state.recentControls,
          loading: false,
          error: action.payload.error,
        },
      };

    default:
      break;
  }
  return state
};